import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

export type TabType = 'expense' | 'income';

const useOpenListCategoryModal = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openListCategory = useMemo(() => {
    const tab = searchParams.get('open-list-category') as TabType;
    return tab === 'expense' || tab === 'income' ? tab : null;
  }, [searchParams]);

  const setOpenListCategory = useCallback((value: TabType | null) => {
    const newParams = new URLSearchParams(searchParams);
    if (value) {
      newParams.set('open-list-category', value);
    } else {
      newParams.delete('open-list-category');
    }
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  return [openListCategory, setOpenListCategory] as const;
};

export default useOpenListCategoryModal;
